import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import packageJson from '../../../package.json';
import { environment } from '../../environments/environment';

/**
 * Ajoute la plateforme (web / ios / android) et la version de l'app aux appels du back,
 * pour les statistiques d'usage (adoption des versions, répartition par plateforme).
 */
@Injectable()
export class ClientContextInterceptor implements HttpInterceptor {
  private readonly platform = Capacitor.getPlatform();
  private readonly appVersion = packageJson.version;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.backAPI)) {
      return next.handle(request);
    }
    return next.handle(request.clone({
      setHeaders: {
        'X-Client-Platform': this.platform,
        'X-App-Version': this.appVersion,
      }
    }));
  }
}
